import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, getHeaders } from '@urc-ui/store/api/base';
import { HttpMethod, Tag } from '@urc-ui/store/api/types';
import { Preference, UpdateUserPreferencesRequest } from '@flexible-reports/store/api/user-preferences/types';

export const CHAT_ACCOUNTS_PREFERENCE_KEY = 'chatSelectedAccountIds';

export const buildPreferenceValue = <T>(userPreferenceValue: T): Preference<T> => ({ value: userPreferenceValue });

export const buildUpdateUserPreferencesRequest = (preferenceName: string, preferenceValue: Preference) => {
  return {
    preferenceName: preferenceName,
    preferenceValue: JSON.stringify(preferenceValue)
  };
};

export const userPreferencesApi = createApi({
  reducerPath: 'userPreferencesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: '/reporting'
  }),
  tagTypes: [Tag.USER_PREFERENCES],
  endpoints: builder => ({
    updateUserPreferences: builder.mutation({
      query: (request: UpdateUserPreferencesRequest) => {
        return {
          url: '/user-preferences',
          method: HttpMethod.POST,
          data: request,
          headers: getHeaders()
        };
      }
    })
  })
});

export const { useUpdateUserPreferencesMutation } = userPreferencesApi;
